import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import {
  getPresetsStatus,
  getPresetsInitResponse,
} from '@wix/da-submit-shared/pkg/redux/selectors';
import { presetsInitFetch } from '@wix/da-submit-shared/pkg/redux/actions';
import { batchEditPreset } from '../../../actions/studio';
import { Props } from './PresetBatchEdit';

export type StateProps = Pick<Props, 'status'>;
export type DispatchProps = Pick<Props, 'fetchPresets' | 'batchEditPreset'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  status: getPresetsStatus(state) || 'uninitialized',
  initResponse: getPresetsInitResponse(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  fetchPresets: () => dispatch(presetsInitFetch(null)),
  batchEditPreset: (presetId: number) =>
    dispatch(batchEditPreset(presetId)),
});

export default connect(mapStateToProps, mapDispatchToProps);
